<!--    客戶-->
<template>
    <div>
        <div :class="{'blur':addFlag}">
            <vs-row style="margin-top: -15px;margin-bottom: 10px">
                <vs-col vs-w="12">
                    <vs-button @click="back()" size="small">{{$t('message.back')}}</vs-button>
                </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-align="center">
                <vs-col vs-w="6">
                    <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.profile')}}</span>
                </vs-col>
                <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
                </vs-col>
            </vs-row>

            <vs-row class="profile" vs-type="flex" vs-justify="center">
                <vs-col vs-w="2" vs-sm="0"></vs-col>
                <vs-col vs-w="5" vs-sm="7">
                    <div :class="isMobile() ? 'profile-title-mob' : 'profile-title'">
                        <p v-if="data.user">{{data.user.username}}</p>
                        <p>{{$t('message.customerCode')}} : {{data.code}}</p>
                        <p v-if="data.agent" v-role="['admin','manager']">{{$t('message.agentNo')}} : {{showAgentNo(data.agent)}}</p>
                    </div>
                    <div :class="isMobile() ? 'profile-body-mob' : 'profile-body'">
                        <p v-if="data.user">{{$t('message.name')}} : {{data.user.name}}</p>
                        <p v-if="data.gender">{{$t('message.gender')}} : {{$t(`message.${data.gender}`)}}</p>
                        <p v-role="['admin','manager']">{{$t('message.dateOfBirth')}} : {{data.dateOfBirth | dateFormat}}</p>
                        <p v-if="data.user" v-role="['admin','manager']">{{$t('message.phone')}} : {{data.user.phone}}</p>
                        <p v-if="data.user" v-role="['admin','manager']">{{$t('message.email')}} : {{data.user.email}}</p>
                        <p v-role="['admin','manager']">{{$t('message.residentialAddress')}} : {{data.residenceAddress}}</p>
                        <p v-role="['admin','manager']">{{$t('message.corrAddress')}} : {{data.correspondenceAddress}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.total_balance')}} : {{data.totalBalance ? data.totalBalance : 0}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.total_credit')}} : {{data.totalCredit ? data.totalCredit : 0}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.total_amount_of_fixed_custody')}} : {{data.fixedTrAccount}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.total_amount_of_current_custody')}} : {{data.demandTrAmount}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.trust_advisor_number')}} : {{data.trustAdvistorNumber}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.trust_account_id')}} : {{data.accountId}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.fixed_custody_account_number')}} : {{data.fixedTrustAccountNumber}}</p>
                        <p v-role="['admin','manager']">{{$t('lang.current_custody_account_number')}} : {{data.demandDepositTrustAmountAccountNumber}}</p>
                    </div>
                </vs-col>
                <vs-col vs-w="5" vs-sm="5">
                    <vs-avatar :size="isMobile() ? '120px' : '250px'" :src="data.user && data.user.profilePic ? data.user.profilePic.fileUrl : ''"/>
                    <vs-button radius color="rgb(37, 105, 193)" size="small" :class="isMobile() ? 'edit-mob': 'edit'" @click="updateInfoFlag = true" v-role="['admin','manager']">Edit</vs-button>
                </vs-col>
            </vs-row>
            
            <!-- summary -->
            <div class="plan-con m-t-3">
                <vs-table :data="summary ? [...summary] : []" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;">{{ $t("message.summary") }}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('updateSummary')" v-role="['admin','manager']">{{ $t("message.update") }}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            {{ $t("lang.credit_card") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.fixed_custody") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.current_custody") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.fixed_return") }}
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span>{{ tr.creditCard }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.fixedCustody }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.currentCustody }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.fixedReturn }}</span>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <!-- summary end -->
            <!-- fixed trust account -->
            <div class="plan-con m-t-3">
                <vs-table :data="fixedTrustAccount" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;">{{ $t("lang.total_amount_of_fixed_custody") }}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('addFixedTrust')" v-role="['admin','manager']">+ {{ $t("lang.add_new") }}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            {{ $t("lang.fixed_custody_number") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.effective_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.maturity_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.management_currency") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.custody_amount") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.standard_return") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.beneficiary") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.beneficiary_after_death") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.deposit_withdrawal") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.amount") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.initial_deposit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.interest_deposit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.note") }}
                        </vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span>{{ tr.fixedNumber }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.date }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.maturityDate }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.currency }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.trustAmount }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.expectedReturn }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.livingBeneficiary }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.deathBeneficiary }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ $t(tr.depositOrWithdrawal) }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.amount }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.initialDeposit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.interestDeposit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.note }}</span>
                            </vs-td>
                            
                            <vs-td>
                                <vs-button size="small" @click="handleEditFixedTrust(tr)" v-role="['admin','manager']">{{$t('message.edit')}}</vs-button>
                            </vs-td>
                            
                            <vs-td>
                                <vs-button size="small" color="rgb(37, 105, 193)" @click="handleDeleteFixedTrust(tr._id)">{{$t('message.delete')}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <!-- fixed trust account end -->
            
            <!-- fixed trust account -->
            <div class="plan-con m-t-3">
                <vs-table :data="demandTrustAmount" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;">{{ $t("lang.total_amount_of_current_custody") }}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('addDemandTrust')" v-role="['admin','manager']">+ {{ $t("lang.add_new") }}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            {{ $t("lang.effective_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.management_currency") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.deposit_withdrawal") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.amount") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.account_balance") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.beneficiary") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.beneficiary_after_death") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.initial_deposit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.interest_deposit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.note") }}
                        </vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span>{{ tr.date }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.currency }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ $t(tr.depositOrWithdrawal) }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.amount }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.accountBalance }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.livingBeneficiary }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.deathBeneficiary }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.initialDeposit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.interestDeposit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.note }}</span>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" @click="handleEditDemandTrust(tr)" v-role="['admin','manager']">{{$t('message.edit')}}</vs-button>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" color="rgb(37, 105, 193)" @click="handleDeleteDemandTrust(tr._id)">{{$t('message.delete')}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <!-- fixed trust account end -->
            <!-- credit card -->
            <div class="plan-con m-t-3">
                <vs-table :data="card ? [...card] : []" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;"> {{ $t("lang.credit_card") }}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('updateCard')" v-role="['admin','manager']">{{ $t("message.update") }}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            <span>{{ $t("lang.card_number") }}</span>
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.expiry_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.card_holder_name") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.total_credit_limit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.used_credit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.remaining_limit") }}
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span style="color: #909090">{{ tr.cardNumber }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.expiryDate }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.cardHolderName }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.totalCardLimit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.usedCredit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.remainingLimit }}</span>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <!-- credit card end -->
            <!-- Latest Transaction -->
            <div class="plan-con m-t-3">
                <vs-table :data="cardTransaction" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;">{{ $t("lang.just_latest_transactions") }}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('addTransaction')" v-role="['admin','manager']">+ {{ $t("lang.add_new") }}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            {{ $t("lang.spending_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.deduct_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.spending_detail") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.spending_location") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.international_ex_fee") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.usd_deduct_amount") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.fx_charge_date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.currency_type") }}
                        </vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span style="color: #909090">{{ moment(tr.spendingDate).format("DD/MM/YYYY") }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ moment(tr.deductDate).format("DD/MM/YYYY") }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.spendingDetail }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.spendingLocation }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.internationalExchangeFee }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.usdDeductAmount }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ moment(tr.fxChargeDate).format("DD/MM/YYYY") }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.currencyType }}</span>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" @click="onEditTransaction(tr)" v-role="['admin','manager']">{{$t('message.edit')}}</vs-button>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" color="rgb(37, 105, 193)" @click="onTransactionDelete(tr._id)">{{$t('message.delete')}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <!-- Latest Transaction -->
            <div class="plan-con m-t-3">
                <vs-table :data="othersAssetsList" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;">{{ $t("lang.others_assets") }}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('AddOtherAsset')" v-role="['admin','manager']">+ {{ $t("lang.add_new") }}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            {{ $t("message.date") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.asset_type") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.unit") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.asset_total") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.before_beneficiary") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.after_beneficiary") }}
                        </vs-th>
                        <vs-th>
                            {{ $t("lang.remark") }}
                        </vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span>{{ moment(tr.date).format("DD/MM/YYYY") }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.asset_type }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.unit }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.asset_total }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.before_beneficiary }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.after_beneficiary }}</span>
                            </vs-td>
                            <vs-td>
                                <span>{{ tr.note }}</span>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" @click="handleEditOthersAssets(tr)" v-role="['admin','manager']">{{$t('message.edit')}}</vs-button>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" color="rgb(37, 105, 193)" @click="onOtherAssetsDelete(tr._id)">{{$t('message.delete')}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <!-- Latest Transaction end -->
            <div class="plan-con m-t-3">
                <vs-table :data="plans" stripe>
                    <template slot="header">
                        <vs-row vs-type="flex" vs-align="center">
                            <vs-col vs-w="6" vs-type="flex" vs-align="center">
                                <span :class="isMobile() ? 'titleMob' : 'title'" style="margin-right: 15px;">{{$t('message.plan')}}</span>
                                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="handleMethods('addPlan')" v-role="['admin','manager']">+ {{$t('message.plan')}}</vs-button>
                            </vs-col>
                            <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                                <span class="time">{{$t('message.lastUpdate')}}: {{data.updatedAt | timeFormat}}</span>
                            </vs-col>
                        </vs-row>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            <span style="color:#959595">{{$t('message.subscriptedPlan')}}</span>
                        </vs-th>
                        <vs-th>
                            {{$t('message.customerCode')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.currency')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.validDate')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.expiryDate')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.balanceAmount')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.expectedAnnualReturn')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.actualAnnualReturn')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.beneficiary')}}
                        </vs-th>
                        <vs-th>
                            {{$t('message.beneficiaryDeath')}}
                        </vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td :data="data[indextr].name">
                                <span style="color: #909090">{{lang == 'en' ? data[indextr].name : data[indextr].name_zh.tran()}}</span>
                            </vs-td>

                            <vs-td>
                                {{code}}
                            </vs-td>

                            <vs-td :data="data[indextr].currency">
                                {{data[indextr].currency}}
                            </vs-td>

                            <vs-td :data="data[indextr].effectiveDate">
                                {{data[indextr].effectiveDate | dateFormat}}
                            </vs-td>
                            <vs-td :data="data[indextr].expiryDate">
                                {{data[indextr].expiryDate | dateFormat}}
                            </vs-td>
                            <vs-td :data="data[indextr].amount">
                                {{data[indextr].amount}}
                            </vs-td>
                            <vs-td :data="data[indextr].expectedAnnualReturn">
                                {{data[indextr].expectedAnnualReturn}}
                            </vs-td>
                            <vs-td :data="data[indextr].actualAnnualReturn">
                                {{data[indextr].actualAnnualReturn}}
                            </vs-td>
                            <vs-td :data="data[indextr].beneficiaries">
                                <div v-if="tr.beneficiaries && tr.beneficiaries[0]">
                                    {{data[indextr].beneficiaries.join(', ').tran()}}
                                </div>
                                <div v-else>
                                    {{data[indextr].beneficiary.tran()}}
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].beneficiariesAfterDeath">
                                <div v-if="tr.beneficiariesAfterDeath && tr.beneficiariesAfterDeath[0]">
                                    {{data[indextr].beneficiariesAfterDeath.join(', ').tran()}}
                                </div>
                                <div v-else>
                                    {{data[indextr].beneficiaryAfterDeath.tran()}}
                                </div>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" @click="onEdit(tr)" v-role="['admin','manager']">{{$t('message.edit')}}</vs-button>
                            </vs-td>
                            <vs-td>
                                <vs-button size="small" color="rgb(37, 105, 193)" @click="onDetail(tr._id)">{{$t('message.details')}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>

        </div>

        <vs-popup :active.sync="updateInfoFlag" title=" ">
            <div class="card-title">
                {{$t('message.updateCustomer')}}
            </div>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <vs-select v-model="agents" autocomplete :placeholder="$t('message.agent')" style="width: 100%" multiple>
                        <vs-select-item :key="index" :value="item._id" :text="`${item.name} (${item.agentNumber})`" v-for="(item,index) in agent" />
                    </vs-select>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input :value="customer.username" disabled style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.name" :placeholder="$t('message.name')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>

            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-select v-model="customer.gender" autocomplete :placeholder="$t('message.gender')" style="width: 100%">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in genderOpt" />
                    </vs-select>
                </vs-col>
                <vs-col vs-w="6">
                    <datepicker class="fixedPicker" v-model="customer.dateOfBirth" :placeholder="$t('message.dateOfBirth')" :format="format"
                                :highlighted="highlight"></datepicker>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.email" :placeholder="$t('message.email')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.phone" :placeholder="$t('message.phone')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.residenceAddress" :placeholder="$t('message.residentialAddress')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.correspondenceAddress" :placeholder="$t('message.corrAddress')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.totalBalance" :placeholder="$t('lang.total_balance')" type="number" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.totalCredit" :placeholder="$t('lang.total_credit')" type="number" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.fixedTrAccount" :placeholder="$t('lang.total_amount_of_fixed_custody')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.demandTrAmount" :placeholder="$t('lang.total_amount_of_current_custody')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.trustAdvistorNumber" :placeholder="$t('lang.trust_advisor_number')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.accountId" :placeholder="$t('lang.trust_account_id')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="6">
                    <vs-input v-model="customer.fixedTrustAccountNumber" :placeholder="$t('lang.fixed_custody_account_number')" style="width: 100%"></vs-input>
                </vs-col>
                <vs-col vs-w="6">
                    <vs-input v-model="customer.demandDepositTrustAmountAccountNumber" :placeholder="$t('lang.current_custody_account_number')" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="onUpdateCustomer()">{{$t('message.update')}}</vs-button>
                </vs-col>
            </vs-row>
        </vs-popup>


        <vs-popup :active.sync="addFlag" title=" ">
            <EditPlan v-if="addFlag" type="add" :data.sync="plan" @add="onCreatePlan" :uploading.sync="uploading" @upload="uploadDocs" />
        </vs-popup>


        <vs-popup :active.sync="updateFlag" title=" ">
            <EditPlan v-if="updateFlag" type="update" :data.sync="plan" @add="onCreatePlan" :uploading.sync="uploading" @upload="uploadDocs" @update="onUpdatePlan" @delete="onDeletePlan" />
        </vs-popup>

        <vs-popup :active.sync="updateCreditCard" title=" ">
            <EditCreditCard v-if="updateCreditCard" :data.sync="card" @update="onUpdateCard" />
        </vs-popup>

        <vs-popup :active.sync="isAddTransaction" title=" ">
            <EditTransaction v-if="isAddTransaction" type="add" @add="onAddTransaction" />
        </vs-popup>

        <vs-popup :active.sync="isUpdateTransaction" title=" ">
            <EditTransaction v-if="isUpdateTransaction" :data.sync="updatedTransaction" type="update" @update="onUpdateTransaction" />
        </vs-popup>
        
        <vs-popup :active.sync="isUpdateSummary" title=" ">
            <EditSummary v-if="isUpdateSummary" :data.sync="summary" @update="onUpdateSummary" />
        </vs-popup>
        
        <vs-popup :active.sync="isAddFixedTrust" title=" ">
            <EditFixedTrust v-if="isAddFixedTrust" type="add" @add="onAddFixedTrustAccount" />
        </vs-popup>
        
        <vs-popup :active.sync="isUpdateFixedTrust" title=" ">
            <EditFixedTrust v-if="isUpdateFixedTrust" :data.sync="updatedFixedTrustData" type="update" @update="onUpdateFixedTrustAccount" />
        </vs-popup>
        
        <vs-popup :active.sync="isAddDemandTrust" title=" ">
            <EditDemandTrust v-if="isAddDemandTrust" type="add" @add="onAddDemandTrustAmount" />
        </vs-popup>

        <vs-popup :active.sync="isAddOthersAsset" title=" ">
            <EditOthersAsset v-if="isAddOthersAsset" type="add" @add="onAddOthersAsset" />
        </vs-popup>

        <vs-popup :active.sync="isUpdateOthersAssets" title=" ">
            <EditOthersAsset v-if="isUpdateOthersAssets" :data.sync="updateOthersAssetsData" type="update" @update="onUpdateOthersAsset" />
        </vs-popup>
        
        <vs-popup :active.sync="isUpdateDemandTrust" title=" ">
            <EditDemandTrust v-if="isUpdateDemandTrust" :data.sync="updatedDemandTrustData" type="update" @update="onUpdateDemandTrustAmount" />
        </vs-popup>
        
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import EditPlan from "@/components/EditPlan";
    import EditCreditCard from "@/components/EditCreditCard";
    import EditTransaction from "@/components/EditTransaction";
    import EditSummary from "@/components/EditSummary";
    import EditFixedTrust from "@/components/EditFixedTrust";
    import EditDemandTrust from "@/components/EditDemandTrust";
    import EditOthersAsset from "@/components/EditOthersAsset";
    import moment from 'moment';
    export default {
        beforeRouteEnter(to,from,next){
            if($cookies.get('role') == 'user'){
                next('/')
            }else{
                next()
            }
        },
        props:["id"],
        name:'customerDetail',
        data() {
            return {
                format: 'dd / MM / yyyy',
                highlight: {
                    customPredictor(date) {
                        if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                            return true;
                    }
                },
                lang:'',
                token:'',
                user:[],
                data:[],
                plans: [],
                code:'',
                card: {},
                cardTransaction: [],
                agent: [],
                agents: [],

                updateInfoFlag:false,
                isAddTransaction: false,
                isUpdateSummary: false,
                isUpdateTransaction: false,
                isAddFixedTrust: false,
                isAddDemandTrust: false,

                isAddOthersAsset: false,

                isUpdateDemandTrust: false,
                isUpdateFixedTrust:false,
                updatedFixedTrustData: {},
                updatedDemandTrustData: {},
                customer:{},
                summary: {},
                fixedTrustAccount: [],
                demandTrustAmount: [],
                othersAssetsList: [],

                isUpdateOthersAssets: false,
                updateOthersAssetsData: {},

                addFlag: false,
                updateFlag:false,
                updateCreditCard: false,
                genderOpt:[
                    {value:'male',text:this.$t('message.male')},
                    {value:'female',text:this.$t('message.female')},
                ],
                plan:{
                    name:'',
                    name_zh:'',
                    currency:'USD',
                    effectiveDate:'',
                    expiryDate:'',
                    amount:'',
                    expectedAnnualReturn:'',
                    actualAnnualReturn:'',
                    beneficiaries: [],
                    beneficiariesAfterDeath: [],
                    totalNetContributionSinceEffectiveDate:'',
                    totalTransferAsset:'',
                    totalTransferOutAsset:'',
                    investmentBalanceSinceEffectiveDate:'',
                    balance:'',
                    return:'',
                    quarterlyFundOverview:'',
                    dividendMode: '',
                    planTemplate: ''
                },
                updatedTransaction: {},
                uploading:false,
            }
        },
        created() {
            this.lang = this.$cookies.get('lang')
            this.token = this.$cookies.get('token')

            this.$vs.loading({
                type:'point'
            })
            let purl = process.env.VUE_APP_API_BASEURL + '/api/customer/' + this.$route.params.id + '?access_token=' + this.$cookies.get('token')
            fetch(purl).then((response) =>{
                return response.json()
            }).then((result)=>{
                this.data = result.responseDetail ;
                this.code = result.responseDetail.code;
                this.plans = result.responseDetail.plans;
                this.fixedTrustAccount = result.responseDetail.fixedTrustAccount;
                this.demandTrustAmount = result.responseDetail.demandTrustAmount;
                if(result.responseDetail.creditCard){
                    this.card = result.responseDetail.creditCard;
                }
                if(result.responseDetail.summary){
                    this.summary = result.responseDetail.summary;
                }
                this.cardTransaction = result.responseDetail.creditCardTransaction;
                this.othersAssetsList = result.responseDetail.othersAssets;
                this.customer = {
                    _id:result.responseDetail._id,
                    username:result.responseDetail.user.username,
                    code:result.responseDetail.code,
                    name:result.responseDetail.user.name,
                    email:result.responseDetail.user.email,
                    phone:result.responseDetail.user.phone,
                    gender:result.responseDetail.gender,
                    dateOfBirth:result.responseDetail.dateOfBirth,
                    residenceAddress:result.responseDetail.residenceAddress,
                    correspondenceAddress:result.responseDetail.correspondenceAddress,

                    totalBalance:result.responseDetail.totalBalance,
                    totalCredit:result.responseDetail.totalCredit,
                    accountId:result.responseDetail.accountId,
                    fixedTrAccount:result.responseDetail.fixedTrAccount,
                    demandTrAmount:result.responseDetail.demandTrAmount,
                    trustAdvistorNumber:result.responseDetail.trustAdvistorNumber,
                    fixedTrustAccountNumber: result.responseDetail.fixedTrustAccountNumber,
                    demandDepositTrustAmountAccountNumber: result.responseDetail.demandDepositTrustAmountAccountNumber,
                }
                this.agents = result.responseDetail.agent.map((item) => item._id);
                if(result){
                    this.$vs.loading.close()
                }
            })


            let aurl = process.env.VUE_APP_API_BASEURL + '/api/user?role[]=agent&status=normal&access_token=' + this.$cookies.get('token');
            fetch(aurl).then((response)=>{
                return response.json()
            }).then((data)=>{
                this.agent = data.responseDetail.data;
            })


        },
        methods: {
            moment,
            onReload(){
                this.$vs.loading({
                    type:'point'
                })
                let purl = process.env.VUE_APP_API_BASEURL + '/api/customer/' + this.$route.params.id + '?access_token=' + this.token;
                fetch(purl).then((response) =>{
                    return response.json()
                }).then((result)=>{
                    this.data = result.responseDetail ;
                    this.code = result.responseDetail.code;
                    this.plans = result.responseDetail.plans;
                    this.card = result.responseDetail.creditCard;
                    this.fixedTrustAccount = result.responseDetail.fixedTrustAccount;
                    this.demandTrustAmount = result.responseDetail.demandTrustAmount;
                    if(result.responseDetail.summary){
                        this.summary = result.responseDetail.summary;
                    }
                    this.cardTransaction = result.responseDetail.creditCardTransaction;
                    this.othersAssetsList = result.responseDetail.othersAssets;
                    this.customer = {
                        _id:result.responseDetail._id,
                        username:result.responseDetail.user.username,
                        code:result.responseDetail.code,
                        name:result.responseDetail.user.name,
                        email:result.responseDetail.user.email,
                        phone:result.responseDetail.user.phone,
                        gender:result.responseDetail.gender,
                        dateOfBirth:result.responseDetail.dateOfBirth,
                        residenceAddress:result.responseDetail.residenceAddress,
                        correspondenceAddress:result.responseDetail.correspondenceAddress,

                        totalBalance:result.responseDetail.totalBalance,
                        totalCredit:result.responseDetail.totalCredit,
                        accountId:result.responseDetail.accountId,
                        fixedTrAccount:result.responseDetail.fixedTrAccount,
                        demandTrAmount:result.responseDetail.demandTrAmount,
                        trustAdvistorNumber:result.responseDetail.trustAdvistorNumber,
                        fixedTrustAccountNumber: result.responseDetail.fixedTrustAccountNumber,
                        demandDepositTrustAmountAccountNumber: result.responseDetail.demandDepositTrustAmountAccountNumber,
                    }
                    
                    this.agents = result.responseDetail.agent.map((item) => item._id);
                    if(result){
                        this.$vs.loading.close()
                    }
                })

            },
            handleMethods(type){
                switch (type){
                    case 'addPlan':{
                        this.plan = {
                            name: '',
                            name_zh: '',
                            currency: 'HKD',
                            effectiveDate:'',
                            expiryDate:'',
                            amount:'',
                            expectedAnnualReturn: '',
                            actualAnnualReturn:'',
                            beneficiaries: [],
                            beneficiariesAfterDeath: [],
                            totalNetContributionSinceEffectiveDate:'',
                            totalTransferAsset:'',
                            totalTransferOutAsset:'',
                            investmentBalanceSinceEffectiveDate:'',
                            balance:'',
                            return:'',
                            quarterlyFundOverview:'',
                            dividendMode: '',
                            planTemplate: ''
                        }
                        this.addFlag = true;
                        break;
                    }
                    case 'updateCard': {
                        this.updateCreditCard = true;
                        break;
                    }
                    case "addTransaction": {
                        this.isAddTransaction = true;
                        break;
                    }
                    case "updateSummary": {
                        this.isUpdateSummary = true;
                        break;
                    }
                    case "addFixedTrust": {
                        this.isAddFixedTrust = true;
                        break;
                    }
                    case "addDemandTrust": {
                        this.isAddDemandTrust = true;
                        break;
                    }
                    case "AddOtherAsset": {
                        this.isAddOthersAsset = true;
                        break;
                    }
                }
            },
            onEdit(item){
                this.plan = JSON.parse(JSON.stringify({
                    ...item,
                    beneficiaries: item.beneficiaries || [],
                    beneficiariesAfterDeath: item.beneficiariesAfterDeath || [],
                    dividendMode: item.dividendMode || '',
                    planTemplate: item.planTemplate || ''
                }));
                this.updateFlag = true;
            },
            onEditTransaction(item){
                this.updatedTransaction = item;
                this.isUpdateTransaction = true;
            },
            onUpdateCustomer(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/customer/' + this.customer._id +'?access_token=' + this.token;
                const {username, code, name, phone, email, gender, dateOfBirth, residenceAddress, correspondenceAddress,fixedTrustAccountNumber, demandDepositTrustAmountAccountNumber, totalBalance, trustAdvistorNumber, totalCredit, accountId, fixedTrAccount, demandTrAmount} = this.customer;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username,
                        password:'',
                        code,
                        name,
                        phone,
                        email,
                        gender,
                        dateOfBirth,
                        residenceAddress,
                        correspondenceAddress, 
                        totalBalance, 
                        trustAdvistorNumber,
                        totalCredit, 
                        accountId,
                        fixedTrAccount,
                        demandTrAmount,
                        fixedTrustAccountNumber,
                        demandDepositTrustAmountAccountNumber,
                        agent: this.agents,
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateInfoFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });

            },
            handleEditFixedTrust(data){
                this.isUpdateFixedTrust = true;
                this.updatedFixedTrustData = data;
            },
            handleEditDemandTrust(data){
                this.isUpdateDemandTrust = true;
                this.updatedDemandTrustData = data;
            },
            handleEditOthersAssets(data){
                this.isUpdateOthersAssets = true;
                this.updateOthersAssetsData = data;
            },
            onDetail(idx){
                this.$router.push({name:'detail',params:{id:idx}})
            },
            handleManageCard(){
                this.$router.push({name:'customerManageCard', params:{id: this.customer._id}})
            },
            uploadDocs(e){
                this.uploading = true;
                let file = e.target.files[0];
                let formData = new FormData();
                formData.append("file", file);
                let url = process.env.VUE_APP_API_BASEURL + '/api/attachment/upload?access_token=' + this.token;
                fetch(url, {
                    method: 'POST',
                    body: formData
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    console.log(result)
                    this.plan.quarterlyFundOverview = result.responseDetail._id;
                    if(result){
                        this.uploading = false;
                    }

                });
            },
            onCreatePlan(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/plan?access_token=' + this.token;
                const {name, name_zh, currency, effectiveDate, expiryDate, amount, expectedAnnualReturn, actualAnnualReturn,
                    beneficiaries, beneficiariesAfterDeath, totalNetContributionSinceEffectiveDate, totalTransferAsset, totalTransferOutAsset,
                    investmentBalanceSinceEffectiveDate, balance, quarterlyFundOverview, dividendMode, planTemplate} = this.plan;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        customer:this.$route.params.id,
                        name,
                        name_zh,
                        currency,
                        effectiveDate,
                        expiryDate,
                        amount,
                        expectedAnnualReturn,
                        actualAnnualReturn,
                        beneficiaries,
                        beneficiariesAfterDeath,
                        totalNetContributionSinceEffectiveDate,
                        totalTransferAsset,
                        totalTransferOutAsset,
                        investmentBalanceSinceEffectiveDate,
                        balance,
                        return: this.plan.return,
                        quarterlyFundOverview,
                        dividendMode,
                        planTemplate,
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.addFlag = false;
                        this.onReload();
                    }
                });
            },
            onUpdatePlan(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/plan/' + this.plan._id + '?access_token=' + this.token;
                const {name, name_zh, currency, effectiveDate, expiryDate, amount, expectedAnnualReturn, actualAnnualReturn,
                    beneficiaries, beneficiariesAfterDeath, totalNetContributionSinceEffectiveDate, totalTransferAsset, totalTransferOutAsset,
                    investmentBalanceSinceEffectiveDate, balance, quarterlyFundOverview, planTemplate, dividendMode} = this.plan;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        name,
                        name_zh,
                        currency,
                        effectiveDate,
                        expiryDate,
                        amount,
                        expectedAnnualReturn,
                        actualAnnualReturn,
                        beneficiaries,
                        beneficiariesAfterDeath,
                        totalNetContributionSinceEffectiveDate,
                        totalTransferAsset,
                        totalTransferOutAsset,
                        investmentBalanceSinceEffectiveDate,
                        balance,
                        return: this.plan.return,
                        quarterlyFundOverview,
                        planTemplate,
                        dividendMode
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    console.log(result)
                    if(result.responseCode === 200){
                        this.updateFlag = false;
                        this.onReload();
                    }
                });
            },
            onUpdateCard(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/customer/credit-card/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    console.log(result)
                    if(result.responseCode === 200){
                        this.updateCreditCard = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onAddTransaction(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/transaction/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isAddTransaction = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onAddOthersAsset(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/others-asset/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isAddOthersAsset = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onAddFixedTrustAccount(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/cash-management/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isAddFixedTrust = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onAddDemandTrustAmount(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/cash-management/demand/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isAddDemandTrust = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onUpdateFixedTrustAccount(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/cash-management/' + data._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'put',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateFixedTrust = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onUpdateDemandTrustAmount(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/cash-management/demand/' + data._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'put',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateDemandTrust = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onUpdateOthersAsset(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/others-asset/' + data._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'put',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateOthersAssets = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            handleDeleteFixedTrust(id){
                if(window.confirm("Are you want to delete this record?")){
                    let url = process.env.VUE_APP_API_BASEURL + '/api/cash-management/' +id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'delete',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateFixedTrust = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
                }
            },
            onOtherAssetsDelete(id){
                if(window.confirm("Are you want to delete this record?")){
                    let url = process.env.VUE_APP_API_BASEURL + '/api/others-asset/' +id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'delete',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateFixedTrust = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
                }
            },
            handleDeleteDemandTrust(id){
                if(window.confirm("Are you want to delete this record?")){
                    let url = process.env.VUE_APP_API_BASEURL + '/api/cash-management/' +id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'delete',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
                }
            },
            onUpdateTransaction(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/transaction/' + data._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'put',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateTransaction = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onUpdateSummary(data){
                let url = process.env.VUE_APP_API_BASEURL + '/api/customer/summary/' + this.customer._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'put',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.isUpdateSummary = false;
                        this.onReload();
                    } else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onTransactionDelete(id){
                if(window.confirm("Do you want to delete this record?")){
                    let url = process.env.VUE_APP_API_BASEURL + '/api/transaction/' + id + '?access_token=' + this.token;
                    fetch(url, {
                        method: 'delete',
                        headers: {
                            'Accept': 'application/json, text/plain, *!/!*',
                            'Content-Type': 'application/json'
                        },
                    }).then((response) => {
                        return response.json()
                    }).catch((error) => {
                    }).then((result) => {
                        if(result.responseCode === 200){
                            this.onReload();
                        } else{
                            this.$vs.notify({
                                title:'提示',
                                text: this.$t('message.errorMsg'),
                                icon: 'clear',
                                color:'danger',
                                position:'top-center',
                                time: 3000
                            });
                        }
                    });
                }
            },
            onDeletePlan(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/plan/delete/' + this.plan._id + '?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.updateFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorDel'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onRemove(type,item){
                switch (type){
                    case 'beneficiary':{
                        this.plan.beneficiaries.splice(item,1);
                        break;
                    }
                    case 'beneficiaryAfterDeath':{
                        this.plan.beneficiariesAfterDeath.splice(item,1);
                        break;
                    }
                }
            },
            showAgentNo(agent){
                return agent.map(item => item.agentNumber).join(', ');
            },
            back(){
                this.$router.go(-1)
            }
        },
        components: {
            Datepicker,
            EditPlan,
            EditCreditCard,
            EditTransaction,
            EditSummary,
            EditFixedTrust,
            EditDemandTrust,
            EditOthersAsset,
        },
        filters: {
            numberFormat(val) {
                return val.toLocaleString()
            },
            nameFormat(val) {
                if($cookies.get('role') == 'agent'){
                    let patrn=/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
                    let patrn1 = /(Mrs|Mr|Miss|Ms|Own)/i ;
                    if(!patrn.exec(val)){
                        if(patrn1.exec(val.split(' ')[0])){
                            return val
                        }else{
                            return val.split(' ')[0] + ' XX'
                        }
                    } else{
                        return val[0] + 'XX'
                    }
                }
                return val
            }
        }
    }
</script>
<style scoped>
    @import '../../assets/css/alert.css';
    @import '../../assets/css/profile.css';
    @import '../../assets/css/table.css';
    .detail-title{
        color: #959595;
        font-weight: 500 !important;
        font-size: 15px;
    }
    .detail-subtitle{
        color: #959595;
        font-weight: 500 !important;
        font-size: 14px;
    }
</style>
